import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IOSSwitch } from "../common/IOSSwitch";

const CookiePreferencesModal = ({
  open,
  onClose,
  preferences,
  onSave,
}) => {
  const { t } = useTranslation();

  const [draft, setDraft] = useState(preferences);

  useEffect(() => {
    if (!open) return;
    setDraft({
      functional: preferences?.functional === true,
      analytics: preferences?.analytics === true,
      marketing: preferences?.marketing === true,
    });
  }, [open, preferences]);

  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-md"
        onClick={onClose}
      />

      <div
        className={`
          relative w-full max-w-[60vw] mobile:max-w-[80vw] mini_mobile:max-w-[80vw]  rounded-2xl
          border border-white/10 shadow-2xl
          bg-[#F1F5F9] text-[#0F172A]
          backdrop-blur-[30px] 
          max-h-[calc(100vh-2rem)] flex flex-col flex flex-col mobile:max-h-[80vh]
        `}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#346DDB]">
          <h2 className="text-[18px] font-bold text-[#346DDB]">
            {t("cookies.preferencesTitle")}
          </h2>
          <button
            onClick={onClose}
            className="text-xl hover:opacity-70 transition"
          >
            ×
          </button>
        </div>

        <div className="
  px-6 py-5 space-y-6 text-sm
  flex-1 overflow-y-auto
  overscroll-contain
">
          <div className="flex items-center justify-between gap-6">
            <div>
              <p className="text-[16px] font-bold text-[#346DDB]">{t("cookies.strictlyNecessary")}</p>
              <p className="text-[15px] mt-1 opacity-80">
                {t("cookies.strictlyNecessaryDesc")}
              </p>
            </div>
            <span className="text-[#346DDB] text-[16px] font-semibold whitespace-nowrap">
              {t("cookies.alwaysActive")}
            </span>
          </div>

          <Row
            label={t("cookies.functional")}
            desc={t("cookies.functionalDesc")}
          >
            <IOSSwitch
              checked={draft.functional}
              onChange={(e) =>
                setDraft((p) => ({
                  ...p,
                  functional: e.target.checked,
                }))
              }
            />
          </Row>

          <Row
            label={t("cookies.analytics")}
            desc={t("cookies.analyticsDesc")}
          >
            <IOSSwitch
              checked={draft.analytics}
              onChange={(e) =>
                setDraft((p) => ({
                  ...p,
                  analytics: e.target.checked,
                }))
              }
            />
          </Row>

          <Row
            label={t("cookies.marketing")}
            desc={t("cookies.marketingDesc")}
          >
            <IOSSwitch
              checked={draft.marketing}
              onChange={(e) =>
                setDraft((p) => ({
                  ...p,
                  marketing: e.target.checked,
                }))
              }
            />
          </Row>
        </div>

        <div className="text-[15px] flex justify-end gap-2 px-6 py-4 border-t border-[#346DDB]">
          <button
            onClick={onClose}
            className="p-[10px] h-[48px] text-[15px] h-[48px] border border-[#346DDB] rounded-md hover:bg-white/10 text-[#346DDB]"
          >
            {t("cookies.cancel")}
          </button>

          <button
            onClick={() => onSave?.(draft)}
            className="p-[10px] h-[48px] text-[15px] rounded-md font-medium
                       bg-[#346DDB] hover:bg-[#346DDB]/80 text-[#ffffff]"
          >
            {t("cookies.savePreferences")}
          </button>
        </div>
      </div>
    </div>
  );
};

const Row = ({ label, desc, children }) => (
  <div className="flex items-center gap-4">
    <div className="flex-1 max-w-[100%]">
      <p className="text-[16px] font-bold leading-snug text-[#346DDB]">{label}</p>
      <p className="mt-1 text-[15px] opacity-80 leading-snug ">
        {desc}
      </p>
    </div>
    <div className="shrink-0 pt-1">{children}</div>
  </div>
);

export default CookiePreferencesModal;
